

class FuelSurchagesEditController {
	/*@ngInject*/
	constructor(Auth, $state, $stateParams, User, FuelSurchargeService, Modal, $translate, UserService, BranchService, SetupService, $q, $scope) {
		this.Auth = Auth;
		this.Modal = Modal;
		this.User = User;
		this.FuelSurchargeService = FuelSurchargeService;
		this.UserService = UserService;
		this.BranchService = BranchService;
		this.SetupService = SetupService;
		this.$q = $q;
		this.$state = $state
		this.$stateParams = $stateParams
		this.$scope = $scope;
		this.$translate = $translate;
		this.permissions = this.Auth.permission();
		this.branchesList = [];
		this.branchId = this.User.getUser().branchId;
		this.errorMessage = '';
		this.appliedList = [
			{
				label: this.$translate.instant('fuel_surcharge.applied_monthly'),
				value: 'MONTHLY'
			},
			{
				label: this.$translate.instant('fuel_surcharge.applied_bi_weekly'),
				value: 'BI_WEEKLY'
			},
			{
				label: this.$translate.instant('fuel_surcharge.applied_weekly'),
				value: 'WEEKLY'
			},
		];
		this.removedFSCIds = [];
		this.localLang = {
			selectAll: this.$translate.instant('common.selectall'),
			selectNone: this.$translate.instant('common.selectnone'),
			reset: this.$translate.instant('shipmentBatch.reset'),
			search: this.$translate.instant('common.search'),
			nothingSelected: this.$translate.instant('common.noneselected'),         //default-label is deprecated and replaced with this.
		};

		this.defaultModel = {
			id: '',
			name: '',
			status: true,
			appliedRange: '',
			branchIds: [],
			branches: [],
			description: '',
			surcharges: [],
			customers: [],
			branchId: this.branchId
		}

		this.model = angular.copy(this.defaultModel)
	}

	$onInit() {
		this.$q.all([
			this.BranchService.all(null, 0, 1000),
			this.FuelSurchargeService.get(this.$stateParams.id)
		])
			.then((data) => {
				let selectedBranches = data[1] && data[1].branches ? data[1].branches.split(",") : []
				// const branchesWithExistingFuelSurchargeRecord = data[1].results.map((setupRecord) => {
				// 	return setupRecord.branchId;
				// });
				this.branches = data[0].results
				// 	.filter((branch) => branchesWithExistingFuelSurchargeRecord.includes(branch.id));

				if (data[1] && data[1].id) {

					this.rawId = data[1].id;
					this.model.id = data[1].id;
					this.model.name = data[1].name;
					this.model.status = data[1].status;
					this.model.appliedRange = data[1].appliedRange;
					this.model.branchIds = selectedBranches;
					this.model.description = data[1].description;
					this.model.surcharges = [];
					this.model.customers = [];
					if (data[1].surcharges && data[1].surcharges.length) {
						data[1].surcharges.forEach(element => {
							element.surcharge = element.surcharge ? element.surcharge + '%' : null
							this.model.surcharges.push(element)
						});
					} else {
						this.addNewSurcharge()
					}
					if (data[1].fuelSurchargeCustomers && data[1].fuelSurchargeCustomers.length) {
						data[1].fuelSurchargeCustomers.forEach(customer => {
							this.model.customers.push(customer)
						});
					}
					selectedBranches.forEach((selectedBranch) => {
						this.branches.filter((branch) => {
							if (branch.id == selectedBranch) {
								branch.ticked = true;
							}
						})
					});
					this.defaultModel = JSON.parse(JSON.stringify(this.model))
				}
			})
			.catch((err) => {
				if (err.data && err.data.errors) {
					err.data.errors.map((e) => {
						this.errorMessage += e.message + '<br/>'
					})
				} else {
					this.errorMessage =  err.data.message ?  err.data.message : err;
				}
			})
	}

	addNewSurcharge() {
		this.model.surcharges.push({
			priceRange: {
				from: this.model.surcharges.length ? parseFloat(this.model.surcharges[this.model.surcharges.length - 1].priceRange.to) + 0.01 : 0.00,
				to: null
			},
			surcharge: ''
		})
	}

	onSurchargeChange(e, i) {
		if (this.model.surcharges && this.model.surcharges.length) {
			this.model.surcharges.forEach((ele, index) => {
				if (this.model.surcharges[index + 1] && (!this.model.surcharges[index + 1].priceRange.from || this.model.surcharges[index].priceRange.to > this.model.surcharges[index + 1].priceRange.from)) {
					this.model.surcharges[index + 1].priceRange.from = parseFloat(this.model.surcharges[index].priceRange.to) + 0.01
				}
			})
		}
	}
	removeSurcharge(index) {
		this.model.surcharges.splice(index, 1)
	}
	removeCustomer(index) {
		this.model.customers[index].isRemoved = true;
		// this.model.customers.splice(index, 1)
		// if (this.model.customers[index] && this.model.customers[index].fuelSurchargeCustomerId) {
		// 	this.removedFSCIds.push(this.model.customers[index].fuelSurchargeCustomerId)
		// }
	}

	getCustomerCount() {
		let activeCustomers = this.model.customers.filter(item => !item.isRemoved);
		return activeCustomers.length
	}
	isSurchargeValid() {
		if (this.model.surcharges.length) {
			let invalidList = this.model.surcharges.filter((item) => (!item.priceRange.to) || (!item.priceRange.to) || (!item.surcharge))
			return invalidList && invalidList.length ? false : true;
		} else {
			return false;
		}
	}
	addNewCustomer() {
		this.Modal.FuelSurchargeCustomer({}, ({ customer, modal }) => {
			modal.close()
			this.model.customers.push(customer)
			this.model.customers = _.uniqBy(this.model.customers, 'id')
		}, ({ modal }) => {
			this.isLoading = false;
			if (modal) modal.close();
		});
	}

	ngPercentage(index) {
		if (this.model.surcharges[index].surcharge) {
			let str = this.model.surcharges[index].surcharge.toString();
			return this.model.surcharges[index].surcharge = str ? str.endsWith('%') ? str : str + '%' : null;
		}
	}
	removePrecentageSign(index) {
		if (this.model.surcharges[index].surcharge && this.model.surcharges[index].surcharge.length) {
			let str = this.model.surcharges[index].surcharge || '';
			return this.model.surcharges[index].surcharge = str.endsWith('%') ? str.replace('%', '') : str;
		}
	}

	submit() {
		let fuelSurcharge = Object.assign({}, this.model)
		if (fuelSurcharge.branchIds && fuelSurcharge.branchIds.length) {
			fuelSurcharge
				.branches = fuelSurcharge.branchIds.map(branchObj => branchObj.id).join(",")
		}
		if (fuelSurcharge.surcharges && fuelSurcharge.surcharges.length) {
			fuelSurcharge.surcharges.map(surchargeObj => {
				let str = surchargeObj.surcharge;
				return surchargeObj.surcharge = str.endsWith('%') ? str.replace('%', '') : str;
			})
		}
		fuelSurcharge = _.pick(fuelSurcharge, Object.keys(this.defaultModel))
		this.loading = true;
		// fuelSurcharge.removedFSCIds = this.removedFSCIds;
		this.FuelSurchargeService.update(this.rawId, fuelSurcharge)
			.then((data) => {
				this.loading = false;
				this.removedFSCIds = [];
				window.history.go(-1)
			})
			.catch((err) => {
				this.loading = false;
				if (err.data && err.data.errors) {
					err.data.errors.map((e) => {
						this.errorMessage += e.message + '<br/>'
					})
				} else {
					this.errorMessage =  err.data.message ?  err.data.message : err;
				}
			})
	}




	autoSelectSameForAll() {
		if (this.model.branchIds.length > 1) return this.model.sameForAll = true;
		else return this.model.sameForAll = false;
	}

	removeSelection() {
		this.model.sameForAll = false;
	}

	resetMultiBranchSelection() {
		if (this.model.branchIds && this.model.branchIds.length) {
			this.branches.forEach(listBranch => {
				if (this.model.branchIds.indexOf(listBranch.id) >= 0) {
					listBranch.ticked = true;
				} else {
					listBranch.ticked = false;
				}
			});

		} else {
			this.branches.forEach(listBranch => {
				listBranch.ticked = false;
			});
		}
	}
	reset() {
		this.model = JSON.parse(JSON.stringify(this.defaultModel));
		this.model.surcharges = [];
		this.model.customers = [];
		this.defaultModel.surcharges.forEach(element => {
			this.model.surcharges.push(element)
		});
		if (this.defaultModel.customers && this.defaultModel.customers.length) {
			this.defaultModel.customers.forEach(customer => {
				this.model.customers.push(customer)
			});
		}
		this.resetMultiBranchSelection();
	}

	goToCustomer = (customerId) => {
		this.$state.go('customer.edit', ({
			id: customerId
		  }))
	}

	showLocations(customerId) {
		this.Modal.FuelSurchargeLocations(this.model, customerId, ({ modal }) => {
			modal.close()
		}, ({ modal }) => {
			if (modal) modal.close();
		});
	}
}

export default FuelSurchagesEditController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/fuel_surcharges/edit/fuel_surcharges.edit.controller.js